import {performHttpRequest} from "@/http/http";

export async function retrieveLnk(x, y) {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/kavel10/retrievelink?x=' + x + '&y=' + y,
        'GET',
    )
}
